<app-string-cell [value]="whitelist()" [wrap]="true"></app-string-cell>
